var ajax_file_upload = {
    'endpoint': '/wp-json/portacool/v1/bazaar_voice_ajax_image_upload',
    'form': '<input type="file" name="file" id="file" />',
    show_form: function(){
        dialog_controller.display_dialog({'title': 'Upload Image', 'content': this.form}, [{text: 'Upload', callback: this.upload_file}]);
    },
    upload_file: function(file, dom){
        formData = new FormData();
        formData.append('file', file);

        if(typeof dom === 'undefined'){
            dom = document; //Emit against the document if no specific dom element is provided
        }

        jQuery.ajax({
            url: ajax_file_upload.endpoint,
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            success: function(response){
                //dialog_controller.display_dialog({'title': 'Upload Image', 'content': JSON.stringify(response)});
                jQuery(dom).trigger('ajax_file_upload:upload_success', response);
            },
            error: function(response){
                //dialog_controller.display_dialog({'title': 'Upload Image', 'content': JSON.stringify(response)});
                jQuery(dom).trigger('ajax_file_upload:upload_error', response);
            }
        });
    }
};

window.ajax_file_upload = ajax_file_upload;